import React from 'react';
import { Box } from '@mui/material';

/**
 * Tiny inline SVG sparkline. `points` = [{t, v}] or [number].
 */
export default function Sparkline({
    points = [],
    width = 120,
    height = 36,
    stroke = '#60a5fa',
    fill = 'rgba(96,165,250,0.16)',
    strokeWidth = 1.75,
}) {
    const values = points.map(p => (typeof p === 'number' ? p : p.v)).filter(v => Number.isFinite(v));
    if (values.length < 2) {
        return <Box sx={{ width, height, opacity: 0.4, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10 }}>—</Box>;
    }
    const min = Math.min(...values);
    const max = Math.max(...values);
    const range = max - min || 1;
    const stepX = width / (values.length - 1);
    const toY = (v) => height - 2 - ((v - min) / range) * (height - 4);
    const path = values.map((v, i) => `${i === 0 ? 'M' : 'L'}${(i * stepX).toFixed(2)},${toY(v).toFixed(2)}`).join(' ');
    const area = `${path} L${width},${height} L0,${height} Z`;

    return (
        <svg width={width} height={height} style={{ display: 'block' }}>
            <path d={area} fill={fill} />
            <path d={path} fill="none" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
